/**
 * 🌍 Übersetzen AUSSERHALB von React-Komponenten (Dienste, Hilfsfunktionen, Toasts aus services/*).
 * Gleiche Sprachdateien und gleiche Rückfall-Kette wie useTranslation(): eingestellte Sprache → Englisch → Deutsch.
 * Die eingestellte Sprache steht in localStorage 'app_language' (LanguageContext schreibt sie); ihre Datei ist
 * geladen, sobald die App läuft. Ist sie (noch) nicht geladen, kommt Englisch.
 *
 *   import { tGlobal } from '../utils/tGlobal';
 *   showToast(tGlobal('printer.notConnected'));
 *   tGlobal('batch.doneToast', { count: 3, time: '10:15' })
 */
import { locales, defaultLanguage, fallbackLanguage, availableLanguages } from '../locales';

const wert = (obj, pfad) => {
  let r = obj;
  for (const k of pfad.split('.')) {
    if (r && typeof r === 'object' && k in r) r = r[k];
    else return undefined;
  }
  return r;
};

export function aktuelleSprache() {
  try {
    const s = localStorage.getItem('app_language');
    if (s && availableLanguages.includes(s)) return s;
  } catch { /* */ }
  const b = (typeof navigator !== 'undefined' && navigator.language || '').split('-')[0];
  return availableLanguages.includes(b) ? b : defaultLanguage;
}

export function tGlobal(key, vars = {}) {
  const lang = aktuelleSprache();
  let s = wert(locales[lang], key);
  if (s === undefined) s = wert(locales[fallbackLanguage], key);
  if (s === undefined) s = wert(locales[defaultLanguage], key);
  if (s === undefined) return key;
  return typeof s === 'string' ? s.replace(/\{\{(\w+)\}\}/g, (m, k) => (vars[k] !== undefined ? vars[k] : m)) : s;
}

export default tGlobal;
